let activeChatId = null;

export const setActiveChatId = (chatId) => {
  activeChatId = chatId != null ? String(chatId) : null;
};

export const clearActiveChatId = () => {
  activeChatId = null;
};

export const isActiveChat = (chatId) => {
  if (!activeChatId || chatId == null) {
    return false;
  }
  return String(chatId) === activeChatId;
};
